import { render, staticRenderFns } from "./RegistrarLock.vue?vue&type=template&id=967c48b4&"
import script from "./RegistrarLock.vue?vue&type=script&lang=js&"
export * from "./RegistrarLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports